import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import T from 'i18n-react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import ReportHeader from '../ReportHeader'
import {
  systemInfoSelector,
  gpuSelector,
} from 'containers/Project/GreenlightReport/selectors'
import SpecTable from 'components/display/SpecTable'
import Subheader from 'components/typography/subheading/index'
import Body2 from 'components/typography/body2/index'
import { segmentSelector } from 'containers/Project/View/selectors'

const mapStateToProps = (state) => {
  return {
     generalInfo: systemInfoSelector(state),
     graphicsInfo: gpuSelector(state),
     segment: segmentSelector(state)
  }
}

class SystemInfo extends Component {
  renderGeneralInfo(){
    return (
      <div styleName='generalInfoContainer'>
        <Subheader theme={styles}>{T.translate('specs.headers.generalInfo')}</Subheader>
        <SpecTable compact moduleName='generalInfo' moduleData={this.props.generalInfo} />
      </div>
    )
  }

  renderGraphicsInfo(){
    const graphicsInfoName = this.props.segment === 'Notebook' ? 'notebookGraphicsInfo' : 'graphicsInfo'
    return (
      <div styleName='graphicsInfoContainer'>
        <Subheader theme={styles}>{T.translate('specs.headers.graphicsInfo')}</Subheader>
        {this.props.graphicsInfo.map((info, index) => (
          <div key={index}>
            <Body2 theme={styles}>{T.translate('specs.headers.gpu', {gpuNumber: info.gpuNumber})}</Body2>
            <SpecTable compact moduleName={graphicsInfoName} moduleData={info} />
          </div>
        ))}
      </div>
    )
  }

  render(){
    return(
      <div>
        <div styleName='systemInfoWrapper'>
          <ReportHeader title={T.translate('finalReport.systemInfoHeader')} />
        </div>
        <div styleName='specTableWrapper'>
          {this.renderGeneralInfo()}
          {this.renderGraphicsInfo()}
        </div>
      </div>
    )
  }
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps)
const enhance = compose(withConnect, withStyles)
export default enhance(SystemInfo)
